import React, { useState, useCallback } from 'react';
import { Auth } from 'aws-amplify';
import Loader from '@ts/ui/Loader';
import { forms } from './data';
import * as S from './styles';

function SignInForm({ setActiveForm }) {
    const [formData, updateFormData] = useState({
        email: '',
        password: '',
    });
    const [error, updateError] = useState('');
    const [isLoading, updateIsLoading] = useState(false);

    React.useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const username = params.get('username');
        if (code && username) {
            Auth.confirmSignUp(username, code);
        }
    }, []);

    const validateForm = useCallback(() => {
        if (!formData.email) {
            updateError('Type your email please');
            return false;
        }
        if (!formData.password) {
            updateError('Type your password please');
            return false;
        }
        updateError('');
        return true;
    }, [formData, updateError]);

    const onChange = useCallback(
        ({ target }) =>
            updateFormData({
                ...formData,
                [target.name]: target.value,
            }),
        [formData, updateFormData]
    );

    const onSubmit = useCallback(
        (event) => {
            event.preventDefault();
            if (validateForm() && !isLoading) {
                updateIsLoading(true);
                const { email, password } = formData;
                Auth.signIn(email, password)
                    .then(() => updateIsLoading(false))
                    .catch((err) => {
                        updateIsLoading(false);
                        updateError(err.message);
                    });
            }
        },
        [validateForm, updateIsLoading, updateError, formData, isLoading]
    );

    return (
        <S.Form>
            <S.InnerTitle>Sign in with your email and password</S.InnerTitle>
            {error && <S.Error>{error}</S.Error>}
            <S.Label htmlFor="email">Email</S.Label>
            <S.Input
                placeholder="Email"
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={onChange}
            />
            <S.Label htmlFor="password">Password</S.Label>
            <S.Input
                placeholder="Password"
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={onChange}
            />
            <S.BlueButton onClick={() => setActiveForm(forms.reset)}>
                Forgot your password?
            </S.BlueButton>
            <S.SubmitButton onClick={onSubmit} disabled={isLoading}>
                {isLoading ? (
                    <S.LoaderWrap>
                        <Loader size="massive" />
                    </S.LoaderWrap>
                ) : (
                    'Sign in'
                )}
            </S.SubmitButton>
            <S.TextWrapper>
                <S.Text>Need an account?</S.Text>
                <S.BlueButton onClick={() => setActiveForm(forms.signup)}>Sign up</S.BlueButton>
            </S.TextWrapper>
        </S.Form>
    );
}

export default SignInForm;
export { SignInForm };
